/* Lusome cooling sheets page: scripts lifted from the approved build. */

(function () {
  var DATA = JSON.parse(document.getElementById('lp-cs-data').textContent);

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* which option value is picked in each row; the key matches the variants map (option1|option2|...) */
  function selected(scope) {
    var vals = [], complete = true, colour = null;
    scope.querySelectorAll('fieldset.variant-picker__option').forEach(function (f, i) {
      var checked = f.querySelector('input[type=radio]:checked');
      if (!checked) { complete = false; return; }
      var label = f.querySelector('label[for="' + checked.id + '"]');
      var name = label ? (label.textContent || '').trim() : checked.value;
      var pos = parseInt(checked.getAttribute('data-option-position') || (i + 1), 10);
      vals[pos - 1] = name;
      if (pos === DATA.colourOption) colour = name;
    });
    return { colour: colour, complete: complete && vals.length > 0, key: vals.join('|') };
  }

  /* Only the gallery on the page itself. The quick-buy modal holds a SECOND copy, and
     un-hiding its photos dumped a giant image over the page while scrolling. */
  function galleries() {
    return [].slice.call(document.querySelectorAll('.product-gallery')).filter(function (g) {
      return !g.closest('quick-buy-modal, x-modal, dialog, .modal, .quick-buy-modal__content');
    });
  }

  /* Remember how an element looked before we ever touched it, so showing it again
     restores the theme's own state instead of forcing it visible. */
  function setShown(el, on) {
    if (!el.hasAttribute('data-lusome-orig-display')) {
      el.setAttribute('data-lusome-orig-display', el.style.display || '');
      el.setAttribute('data-lusome-orig-hidden', el.hidden ? '1' : '0');
    }
    if (on) {
      el.style.display = 'block';
      el.hidden = false;
    } else {
      el.style.display = 'none';
      el.hidden = true;
    }
  }

  /* Reorder matching children of `host` to follow `ids`, leaving everything else alone. */
  function order(host, selector, ids) {
    if (!host) return;
    var byId = {};
    host.querySelectorAll(selector).forEach(function (el) { byId[el.getAttribute('data-media-id')] = el; });
    var anchor = byId[ids[0]];
    if (!anchor) return;
    var prev = anchor;
    host.insertBefore(anchor, host.firstChild);
    for (var i = 1; i < ids.length; i++) {
      var el = byId[ids[i]];
      if (!el) continue;
      prev.after(el);
      prev = el;
    }
  }

  /* Is this gallery already showing exactly these pictures, in this order? If it is, leave it alone.
     Without this check the work below reorders live nodes, the page's own MutationObserver sees that
     as a change and fires lp:resync, and we run again in a loop. Every pass sent the carousel back to
     the first picture, so clicking a thumbnail or an arrow appeared to do nothing (Allan, 06/09). */
  function alreadyShowing(gal, ids) {
    var shown = [].slice.call(gal.querySelectorAll('.product-gallery__media')).filter(function (m) {
      return !m.hidden && m.style.display !== 'none';
    });
    if (shown.length !== ids.length) return false;
    for (var i = 0; i < ids.length; i++) {
      if (shown[i].getAttribute('data-media-id') !== ids[i]) return false;
    }
    return true;
  }

  function showColourImages(colour) {
    var ids = DATA.groups[colour];
    if (!ids) return;
    var keep = {};
    ids.forEach(function (id) { keep[id] = true; });
    galleries().forEach(function (gal) {
      if (alreadyShowing(gal, ids)) return;
      gal.querySelectorAll('.product-gallery__media').forEach(function (m) {
        setShown(m, !!keep[m.getAttribute('data-media-id')]);
      });
      gal.querySelectorAll('.product-gallery__thumbnail').forEach(function (t) {
        setShown(t, !!keep[t.getAttribute('data-media-id')]);
        /* the theme tracks the selected thumbnail by its original index, which no longer
           applies once the list is filtered, so mark it here instead */
        t.setAttribute('aria-current', 'false');
      });
      var lead = gal.querySelector('.product-gallery__thumbnail[data-media-id="' + ids[0] + '"]');
      if (lead) lead.setAttribute('aria-current', 'true');
      /* Put this colour's photos in Allan's order: folded set first, room shot second.
         Moving the live nodes keeps the markup intact. */
      order(gal.querySelector('.product-gallery__carousel'), '.product-gallery__media', ids);
      order(gal.querySelector('.product-gallery__thumbnail-scroller'), '.product-gallery__thumbnail', ids);
      var car = gal.querySelector('.product-gallery__carousel');
      if (car) car.scrollTo({ left: 0, behavior: 'auto' });
    });
  }

  /* Write only when the content actually differs. Rewriting identical text still counts as a change
     to the buy box's MutationObserver below, which fires lp:resync, which lands back here: the price
     line, gift tag and button were being rebuilt about 16 times a second for as long as the page was
     open, which on a phone cost seconds of processing and made the gift tag twitch (14/10/2026). */
  function setHTML(el, html) { if (el.innerHTML !== html) el.innerHTML = html; }
  function setText(el, text) { if (el.textContent !== text) el.textContent = text; }

  function updatePrice(sel) {
    var v = DATA.variants[sel.key];
    if (!v) return;
    var GIFT_VALUE = DATA.giftCents;  /* the three gift tiles above the colour row: $48 + $50 + $100 */
    /* price line: struck compare (sheets + $198 of gifts), the real price large, and a value tag */
    document.querySelectorAll('price-list.price-list--product').forEach(function (pl) {
      var sale = pl.querySelector('sale-price');
      if (!sale) return;
      setHTML(sale, '<span class="sr-only">Price</span>' + money(v.price));
      var cmp = pl.querySelector('.lusome-compare-at');
      if (!cmp) { cmp = document.createElement('s'); cmp.className = 'lusome-compare-at'; pl.insertBefore(cmp, sale); }
      setText(cmp, money(v.price + GIFT_VALUE));
      var tag = pl.querySelector('.lusome-value-tag');
      if (!tag) { tag = document.createElement('span'); tag.className = 'lusome-value-tag'; pl.appendChild(tag); }
      setText(tag, DATA.giftTitle ? 'Free ' + DATA.giftTitle : '$' + (GIFT_VALUE / 100) + ' in free gifts');
    });
    /* the button shows sheets + the $198 of free gifts struck out, then the real price */
    document.querySelectorAll('[data-lusome-cart-price]').forEach(function (el) {
      setHTML(el, '<s>' + money(v.price + GIFT_VALUE) + '</s> ' + money(v.price));
    });
    var sz = document.getElementById('sezzle-widget-v2-price');
    if (sz) setText(sz, money(v.price));
    document.querySelectorAll('form.shopify-product-form input[name=id]').forEach(function (i) {
      i.value = v.id;
    });
  }

  function sync() {
    watchCarousels();
    var scope = document.querySelector('.product-info') || document;
    var sel = selected(scope);
    if (sel.colour) showColourImages(sel.colour);
    if (sel.complete) updatePrice(sel);
  }

  function mainGallery(el) {
    var g = el.closest('.product-gallery');
    return (g && !g.closest('quick-buy-modal, x-modal, dialog, .modal, .quick-buy-modal__content')) ? g : null;
  }
  function markCurrent(gal, mid) {
    gal.querySelectorAll('.product-gallery__thumbnail').forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-media-id') === mid ? 'true' : 'false');
    });
    /* keep the highlighted thumbnail inside the rail's own scroll box; the page itself never moves */
    var cur = gal.querySelector('.product-gallery__thumbnail[data-media-id="' + mid + '"]');
    var rail = gal.querySelector('.product-gallery__thumbnail-scroller');
    if (cur && rail) {
      var top = cur.offsetTop - rail.offsetTop, bottom = top + cur.offsetHeight;
      if (top < rail.scrollTop) rail.scrollTop = top - 4;
      else if (bottom > rail.scrollTop + rail.clientHeight) rail.scrollTop = bottom - rail.clientHeight + 4;
      var left = cur.offsetLeft - rail.offsetLeft, right = left + cur.offsetWidth;
      if (left < rail.scrollLeft) rail.scrollLeft = left - 4;
      else if (right > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = right - rail.clientWidth + 4;
    }
  }
  function scrollToMedia(gal, mid) {
    var m = gal.querySelector('.product-gallery__media[data-media-id="' + mid + '"]');
    if (!m) return;
    /* instant jump: reliable in every browser, and block:nearest keeps the page still */
    m.scrollIntoView({ behavior: 'auto', inline: 'start', block: 'nearest' });
    markCurrent(gal, mid);
  }
  /* capture phase, so the theme's own (now stale) thumbnail handler never runs */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.product-gallery__thumbnail');
    if (!t) return;
    var gal = mainGallery(t);
    if (!gal) return;
    e.preventDefault(); e.stopImmediatePropagation();
    scrollToMedia(gal, t.getAttribute('data-media-id'));
  }, true);
  function visibleMedia(gal) {
    return [].slice.call(gal.querySelectorAll('.product-gallery__media')).filter(function (m) {
      return !m.hidden && m.style.display !== 'none';
    });
  }
  function inViewMedia(gal) {
    var car = gal.querySelector('.product-gallery__carousel');
    if (!car) return null;
    var cr = car.getBoundingClientRect(), best = null, bo = 0;
    visibleMedia(gal).forEach(function (m) {
      var r = m.getBoundingClientRect();
      var ov = Math.max(0, Math.min(r.right, cr.right) - Math.max(r.left, cr.left));
      if (ov > bo) { bo = ov; best = m; }
    });
    return best;
  }
  /* the side arrows step through this colour's photos */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lusome-prev], [data-lusome-next]');
    if (!btn) return;
    var gal = mainGallery(btn);
    if (!gal) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var list = visibleMedia(gal), cur = inViewMedia(gal);
    var i = Math.max(0, list.indexOf(cur));
    var j = btn.hasAttribute('data-lusome-next') ? Math.min(list.length - 1, i + 1) : Math.max(0, i - 1);
    if (list[j]) scrollToMedia(gal, list[j].getAttribute('data-media-id'));
  }, true);

  /* keep the highlighted thumbnail in step with whatever photo is in view */
  function watchCarousels() {
    galleries().forEach(function (gal) {
      var car = gal.querySelector('.product-gallery__carousel');
      if (!car || car.hasAttribute('data-lusome-watched')) return;
      car.setAttribute('data-lusome-watched', '1');
      var timer = null;
      car.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var cr = car.getBoundingClientRect(), best = null, bestOv = 0;
          car.querySelectorAll('.product-gallery__media').forEach(function (m) {
            if (m.hidden || m.style.display === 'none') return;
            var r = m.getBoundingClientRect();
            var ov = Math.max(0, Math.min(r.right, cr.right) - Math.max(r.left, cr.left));
            if (ov > bestOv) { bestOv = ov; best = m; }
          });
          if (best) markCurrent(gal, best.getAttribute('data-media-id'));
        }, 120);
      }, { passive: true });
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('fieldset.variant-picker__option input[type=radio]')) sync();
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest('fieldset.variant-picker__option label')) setTimeout(sync, 60);
  });
  /* Sezzle renders "$82.00 CAD" itself a moment after load; Allan wants no currency code */
  var sezzleTries = 0;
  (function trimSezzle() {
    document.querySelectorAll('.sezzle-button-text, .sezzle-payment-amount').forEach(function (el) {
      el.childNodes.forEach(function (n) { if (n.nodeType === 3 && /\bCAD\b/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\s*CAD\b/g, ''); });
    });
    if (++sezzleTries < 20) setTimeout(trimSezzle, 500);
  })();
  sync();  /* loaded deferred, so the product section is already parsed */
  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('lp:resync', sync);
  window.addEventListener('load', sync);
})();


/* Banner on the first product image: dismiss, the study footnote, and a jump to the reviews. */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-lusome-proof-close]')) {
      /* the cross folds the banner into a small tab (Allan, 06/09), on every colour at once;
         a click on the tab opens it again */
      document.querySelectorAll('[data-lusome-proof]').forEach(function (el) { el.classList.add('is-collapsed'); });
    } else if (t.closest('[data-lusome-proof].is-collapsed')) {
      document.querySelectorAll('[data-lusome-proof]').forEach(function (el) { el.classList.remove('is-collapsed'); });
    } else if (t.closest('[data-lusome-proof-note]')) {
      var wrap = t.closest('[data-lusome-proof]');
      var note = wrap && wrap.querySelector('.lusome-proof__note');
      var show = note ? note.hidden : false;
      document.querySelectorAll('[data-lusome-proof] .lusome-proof__note').forEach(function (n) { n.hidden = !show; });
    } else if (t.closest('[data-lusome-proof-reviews]')) {
      /* the full review list at the bottom of the page, never the little badge under the title */
      var target = document.querySelector('.lp-cs-review-wall, .jdgm-review-widget');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();


/* keep the date current so the notice never reads as stale */
(function () {
  try {
    var el = document.querySelector('[data-lusome-today]');
    if (el) el.textContent = new Date().toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' });
  } catch (e) {}
})();


/* ---- Shopify build additions ---- */
(function () {
  /* awards badges as an endless marquee: the theme's three cards, repeated, in a moving track */
  function marquee() {
    document.querySelectorAll('.lp-cs-badges multi-column, .lp-cs-badges .multi-column').forEach(function (host) {
      if (host.closest('.lp-marquee')) return;
      var items = [].slice.call(host.children).filter(function (c) { return c.classList.contains('multi-column__item'); });
      if (items.length < 2) return;
      var track = document.createElement('div');
      track.className = 'lp-marquee__track';
      for (var r = 0; r < 4; r++) {
        items.forEach(function (it) {
          var d = document.createElement('div');
          d.className = 'lp-marquee__item';
          d.innerHTML = it.innerHTML;
          track.appendChild(d);
        });
      }
      var wrap = document.createElement('div');
      wrap.className = 'lp-marquee';
      wrap.setAttribute('aria-label', 'Awards and recognition');
      wrap.appendChild(track);
      host.replaceWith(wrap);
    });
  }
  marquee();
  document.addEventListener('shopify:section:load', marquee);

  /* sticky buy bar: appears once the real Add to cart button has scrolled off the top */
  function stickyParts() {
    return { bar: document.querySelector('[data-lp-sticky]'),
             btn: document.querySelector('.lp-cs-buy-box [data-block-type="buy-buttons"] button[type=submit]') };
  }
  function stickyUpdate() {
    var p = stickyParts();
    if (!p.bar || !p.btn) return;
    p.bar.classList.toggle('is-visible', p.btn.getBoundingClientRect().bottom < 0);
  }
  window.addEventListener('scroll', stickyUpdate, { passive: true });
  window.addEventListener('resize', stickyUpdate);
  window.addEventListener('load', stickyUpdate);
  stickyUpdate();
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-lp-sticky-add]')) return;
    e.preventDefault();
    var p = stickyParts();
    if (p.btn) p.btn.click();
  });

  /* Review Wall: the chosen product's Judge.me reviews, fetched from Judge.me and drawn here.
     Judge.me's own widget only fills itself in on a product page; this is a /pages/ address. */
  (function () {
    var host = document.querySelector('[data-lp-jm]');
    if (!host) return;
    var shop = host.getAttribute('data-shop'), pid = host.getAttribute('data-product-id');
    var per = parseInt(host.getAttribute('data-per-page') || '6', 10), page = 1, pages = 1;
    var list = host.querySelector('.lp-jm__list'), summary = host.querySelector('.lp-jm__summary'), more = host.querySelector('.lp-jm__more');
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function stars(n) { var o = ''; for (var i = 1; i <= 5; i++) o += '<span class="lp-jm__star' + (i <= n ? ' is-on' : '') + '">&#9733;</span>'; return o; }
    function when(iso) { try { return new Date(iso).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' }); } catch (e) { return ''; } }
    function card(r) {
      var pics = (r.pictures_urls || []).map(function (u) { return '<img src="' + esc(u.compact || u.original || u) + '" alt="" loading="lazy">'; }).join('');
      return '<article class="lp-jm__card">'
        + '<div class="lp-jm__stars" aria-label="' + r.rating + ' out of 5 stars">' + stars(r.rating) + '</div>'
        + (r.title ? '<h3 class="lp-jm__title">' + esc(r.title) + '</h3>' : '')
        + '<div class="lp-jm__body">' + (r.body_html || esc(r.body)) + '</div>'
        + (pics ? '<div class="lp-jm__pics">' + pics + '</div>' : '')
        + '<footer class="lp-jm__by"><span class="lp-jm__avatar">' + esc((r.reviewer_initial || (r.reviewer_name || '?')[0]).toUpperCase()) + '</span>'
        + '<span class="lp-jm__name">' + esc(r.reviewer_name || 'Anonymous') + '</span>'
        + (r.verified_buyer ? '<span class="lp-jm__verified">Verified buyer</span>' : '')
        + '<time class="lp-jm__date">' + when(r.created_at) + '</time></footer></article>';
    }
    function load() {
      more.disabled = true;
      var url = 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop)
        + '&platform=shopify&page=' + page + '&per_page=' + per + '&product_id=' + encodeURIComponent(pid);
      fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        if (page === 1) {
          summary.innerHTML = '<div class="lp-jm__stars lp-jm__stars--lg">' + stars(Math.round(parseFloat(j.average_rating) || 0)) + '</div>'
            + '<p class="lp-jm__avg"><strong>' + esc(j.average_rating) + '</strong> out of 5, ' + esc(j.number_of_reviews) + ' reviews</p>';
          list.innerHTML = '';
        }
        (j.reviews || []).forEach(function (r) { list.insertAdjacentHTML('beforeend', card(r)); });
        pages = (j.pagination && j.pagination.total_pages) || 1;
        more.hidden = page >= pages;
        more.disabled = false;
        page += 1;
      }).catch(function () { more.hidden = true; });
    }
    more.addEventListener('click', load);
    load();
  })();

  /* no email popup on this page (Allan, 2026-09-04). Klaviyo re-injects it and can lock scrolling,
     so a cheap timer sweeps it away for the first minute. The footer newsletter form is left alone. */
  (function () {
    var scrollLock = 'klaviyo-prevent-body-scrolling';
    var sweep = function () {
      if (document.body && document.body.classList.contains(scrollLock)) document.body.classList.remove(scrollLock);
      var hits = document.querySelectorAll('[data-kl-scroll-locking-modal],[class*="kl-teaser"],[role="dialog"][aria-label*="POPUP"],.klaviyo-form[data-testid="klaviyo-form"]');
      for (var i = 0; i < hits.length; i++) {
        var el = hits[i];
        if (el.closest('.footer, footer, .shopify-section-group-footer-group')) continue;
        var top = el;
        while (top.parentElement && top.parentElement !== document.body) top = top.parentElement;
        if (top.closest && top.closest('.shopify-section-group-footer-group')) continue;
        top.remove();
      }
    };
    var timer = setInterval(sweep, 500);
    setTimeout(function () { clearInterval(timer); sweep(); }, 60000);
    sweep();
  })();

  /* ---- gifts and the gift discount: NOT OURS ANY MORE (Allan, 13/09/2026) ----
     Lusome runs a gift-with-purchase app (506 / EasyGift). It adds the free items itself and its rule
     has "prevent customers purchasing added items outside of this rule" switched on, so anything we
     added was blocked and alerted at the shopper. Two separate discount codes also proved unable to
     stack: Shopify keeps one product discount code and drops the other. So the whole gift and discount
     machinery is gone from this page: no auto-add, no /discount/ stamping, no checkout intercept and
     no tidy-up. The app owns the offer end to end. The gift TILES in the buy box are display only and
     stay. If this ever needs to come back, it is in Git before commit "let the app handle the gifts". */

  /* the theme re-renders the product section on a variant change; re-run our sync when it does */
  var box = document.querySelector('.lp-cs-buy-box');
  if (box && window.MutationObserver) {
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { document.dispatchEvent(new CustomEvent('lp:resync')); }, 60);
    }).observe(box, { childList: true, subtree: true });
  }

  /* Every slide but the first is lazy AND inside a hidden box, so the browser starts fetching a
     colour's two pictures only when you click that colour, which showed as a pause (Allan, 06/09).
     Once the page is idle we fetch them at the size the gallery is actually using, so the switch is
     instant. Idle work only: nothing here delays first paint. */
  function warmColourImages() {
    var gal = document.querySelector('#lp-buy-box .product-gallery');
    if (!gal || gal.hasAttribute('data-lp-warmed')) return;
    gal.setAttribute('data-lp-warmed', '1');
    var shown = gal.querySelector('.product-gallery__media:not([hidden]) img');
    var want = shown ? (shown.currentSrc || shown.src) : null;
    if (!want) return;
    var width = (want.match(/[?&]width=(\d+)/) || [])[1];
    gal.querySelectorAll('.product-gallery__media[hidden] img, .product-gallery__media[style*="display: none"] img').forEach(function (img) {
      var src = img.getAttribute('src');
      if (!src) return;
      if (width) src = src.replace(/([?&]width=)\d+/, '$1' + width);
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = src;
    });
  }
  function warmWhenIdle() {
    if (window.requestIdleCallback) requestIdleCallback(warmColourImages, { timeout: 4000 });
    else setTimeout(warmColourImages, 1500);
  }
  window.addEventListener('load', warmWhenIdle);
  if (document.readyState === 'complete') warmWhenIdle();

  /* Review wall: show a first page of Judge.me's own cards, the rest behind Load more */
  function reviewWall() {
    document.querySelectorAll('[data-lp-jm-ssr]').forEach(function (w) {
      if (w.hasAttribute('data-lp-done')) return;
      w.setAttribute('data-lp-done', '1');
      var per = parseInt(w.getAttribute('data-per-page'), 10) || 8;
      var revs = [].slice.call(w.querySelectorAll('.jdgm-rev'));
      var btn = w.querySelector('.lp-jm-ssr__more');
      var shown = 0;
      function step() {
        revs.forEach(function (r, i) { r.hidden = i >= shown + per; });
        shown += per;
        if (btn) btn.hidden = shown >= revs.length;
      }
      if (!revs.length) { if (btn) btn.hidden = true; return; }
      step();
      if (btn) btn.addEventListener('click', step);
    });
  }
  /* Judge.me leaves the <time> empty for its own script to fill; on this page we fill it ourselves */
  function reviewDates() {
    document.querySelectorAll('[data-lp-jm-ssr] .jdgm-rev__timestamp').forEach(function (t) {
      if (t.textContent.trim()) return;
      var d = new Date(t.getAttribute('datetime'));
      if (isNaN(d)) return;
      t.textContent = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
      t.classList.remove('jdgm-spinner');
    });
  }
  document.addEventListener('DOMContentLoaded', function () { reviewWall(); reviewDates(); });
  reviewWall(); reviewDates();

  /* Desktop thumbnail rail: exactly as tall as the picture beside it, never longer (Allan, 06/09).
     Nine thumbnails per colour overflow a square picture, so the rail scrolls inside that height and
     follows the highlighted thumbnail. Below 1000px the rail is a horizontal row and needs no cap. */
  function fitRail() {
    document.querySelectorAll('.product-gallery').forEach(function (gal) {
      var car = gal.querySelector('.product-gallery__carousel');
      var rail = gal.querySelector('.product-gallery__thumbnail-scroller');
      if (!car || !rail) return;
      if (window.innerWidth >= 1000) {
        var h = car.getBoundingClientRect().height;
        if (h > 100) rail.style.maxHeight = Math.round(h) + 'px';
      } else {
        rail.style.maxHeight = '';
      }
    });
  }
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(function () { fitRail(); });
    var arm = function () {
      document.querySelectorAll('.product-gallery__carousel').forEach(function (c) {
        if (!c.hasAttribute('data-lp-rail-watched')) { c.setAttribute('data-lp-rail-watched', '1'); ro.observe(c); }
      });
      fitRail();
    };
    document.addEventListener('DOMContentLoaded', arm);
    document.addEventListener('lp:resync', arm);
    window.addEventListener('load', fitRail);
    window.addEventListener('resize', fitRail);
    arm();
  }
})();
